module.exports = __webpack_public_path__ + "img/farzana-christopher-71.768c6e3f.jpg";